module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('sk-panel', [_c('h3', [_vm._v("Confirm Your Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [
    [(_vm.facebookPixelSKShow) ? _c('img', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "height": "1",
        "width": "1",
        "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
      }
    }) : _vm._e()], _vm._v(" "), _c('sk-form', {
      staticClass: "form",
      attrs: {
        "id": "checkout-form"
      },
      on: {
        "submit": function($event) {
          _vm.checkPayment()
        }
      }
    }, [_c('p', {
      staticClass: "form-alert"
    }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "name": "name",
        "autocomplete": "name",
        "label": "Your name",
        "required": "",
        "error-message": {
          valueMissing: 'Please tell us your name.'
        }
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.user.FullName),
        callback: function($$v) {
          _vm.$set(_vm.user, "FullName", $$v)
        },
        expression: "user.FullName"
      }
    })], 1)], 1), _vm._v(" "), _c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "name": "email",
        "type": "email",
        "autocomplete": "email",
        "label": "Your email",
        "required": "",
        "error-message": {
          valueMissing: 'Please make sure your email address follows this format: example@email.com'
        }
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.originalEmail),
        callback: function($$v) {
          _vm.originalEmail = $$v
        },
        expression: "originalEmail"
      }
    }, [_c('template', {
      slot: "help"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": _vm.isGuest ? 'We\'ll email your booking confirmation to you.' : 'We\'ll email your booking confirmation to you. Changing your email address here will not affect your profile.',
        "action-text": "Why do I need to provide my email address?"
      }
    })], 1)], 2), _vm._v(" "), _c('sk-flex', {
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('sk-input', {
      attrs: {
        "name": "tmpEmail",
        "type": "email",
        "label": "Confirm email",
        "required": "",
        "error-message": {
          valueMissing: 'Please make sure your email address follows this format: example@email.com'
        }
      },
      model: {
        value: (_vm.tmpEmail),
        callback: function($$v) {
          _vm.tmpEmail = $$v
        },
        expression: "tmpEmail"
      }
    }, [(_vm.confirmEmail != undefined) ? [(!_vm.confirmEmail) ? _c('div', {
      staticClass: "form-group__error"
    }, [_vm._v("Email addresses do not match.")]) : _vm._e()] : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-input', {
      staticClass: "light-input",
      attrs: {
        "type": "tel",
        "name": "mobile",
        "autocomplete": "tel",
        "label": "Your mobile number",
        "required": "",
        "error-message": {
          valueMissing: 'Please enter your mobile number',
          patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
        },
        "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
      },
      on: {
        "input": function($event) {
          _vm.user.isTemp = true
        }
      },
      model: {
        value: (_vm.user.MobilePhone),
        callback: function($$v) {
          _vm.$set(_vm.user, "MobilePhone", $$v)
        },
        expression: "user.MobilePhone"
      }
    }, [_c('template', {
      slot: "help"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": _vm.isGuest ? 'We might need to reach you should there be changes that impact your booking.' : 'We might need to reach you should there be changes that impact your booking. Changing your number here will not affect your profile.',
        "action-text": "Why do I need to provide my mobile number?"
      }
    })], 1)], 2), _vm._v(" "), (_vm.isGuest && _vm.user.isTemp) ? _c('sk-checkbox', {
      attrs: {
        "id": "userLinkCards",
        "label": "Save this information for next time"
      },
      model: {
        value: (_vm.saveUserData),
        callback: function($$v) {
          _vm.saveUserData = $$v
        },
        expression: "saveUserData"
      }
    }, [_c('template', {
      slot: "append"
    }, [_c('sk-tooltip', {
      attrs: {
        "content": "We use cookies to store your details and speed up your booking the next time you visit."
      }
    })], 1)], 2) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("By clicking pay, you agree to our "), _c('a', {
      attrs: {
        "href": "/content/legal/online-booking-terms-and-conditions",
        "target": "_blank"
      }
    }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "payment-info": ""
      }
    }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "text-right": ""
      }
    }, [_c('p', {
      staticClass: "text--small"
    }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs3": "",
        "sm6": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/visa.png",
        "alt": "Visa"
      }
    })]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs3": "",
        "sm6": ""
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/img/master-card.png",
        "alt": "Master Card"
      }
    })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
      class: _vm.$breakpoints.smDown ? 'text-right' : '',
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "payment-footer": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [(!_vm.$breakpoints.smDown) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/3"
      }
    }, [_vm._v("Back")]) : _vm._e()], 1), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "grow": "",
        "text-right": ""
      }
    }, [(_vm.confirmEmail) ? _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "payment-footer-btns": ""
      }
    }, [(_vm.order.totalInCents !== 0) ? [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "type": "submit"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.eft = false
        }
      }
    }, [_c('sk-icon', {
      attrs: {
        "lock": ""
      }
    }), _vm._v(" Pay With Credit Card\n                                        ")], 1)], 1)] : [_c('sk-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "primary": "",
        "type": "submit"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.eft = false;
        }
      }
    }, [_vm._v("Complete Order")])], 1)]], 2) : _vm._e()], 1), _vm._v(" "), (_vm.$breakpoints.smDown) ? _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md2": ""
      }
    }, [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": "/booking/3"
      }
    }, [_vm._v("Back")])], 1) : _vm._e()], 1)], 1)
  ], 2)]) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.leaveSite),
      callback: function($$v) {
        _vm.leaveSite = $$v
      },
      expression: "leaveSite"
    }
  }, [_c('h3', [_vm._v("Payment notice")]), _vm._v(" "), _c('p', [_vm._v("By clicking PAY, you'll be redirected to our payment page. Please don’t close your browser until you’ve received your booking reference.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.makePayment()
      }
    }
  }, [_vm._v("Got it!")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leaveSite = false
      }
    }
  }, [_vm._v("Wait! Take me back")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.prepareError),
      callback: function($$v) {
        _vm.prepareError = $$v
      },
      expression: "prepareError"
    }
  }, [_c('h3', [_vm._v("Oops!")]), _vm._v(" "), _c('p', [_vm._v("Something went wrong, please try again!")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prepareError = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a1c5f4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/checkout/checkout.vue
// module id = 740
// module chunks = 0